import { Button, Typography } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import { useAppSelector, useTranslate } from 'hooks';

import { Paper } from 'componets/ui';
import { Verify2FASteps } from 'pages/Verify2FASteps';
import { RegistrationLayout } from 'componets/layouts';

import { Paths } from 'utils/constants';

import { selectUser } from 'selectors';

import styles from '../index.module.scss';

export const Verify2FA = () => {
	const t = useTranslate(['faLabelText', 'faLabel2Text', 'setupFaText', 'setupLaterText']);

	const user = useAppSelector(selectUser);
	const navigate = useNavigate();
	const [isStartVerify, setIsStartVerify] = useState(false);

	return (
		<RegistrationLayout email={user.email}>
			<Paper styleName={styles.blockForm}>
				<Typography.Title level={4} className={styles.veriffTitle}>
					{t.faLabelText}
				</Typography.Title>
				<Typography.Text className={styles.verifyText}>{t.faLabel2Text}</Typography.Text>
				<Button type="primary" size="large" block onClick={() => setIsStartVerify(true)}>
					{t.setupFaText}
				</Button>
			</Paper>
			<div
				className={classNames(styles.verifyLater, styles.verifyLaterFA)}
				role="button"
				onClick={() => navigate(Paths.VERIFY_IDENTITY)}
			>
				<Typography.Text type="secondary">{t.setupLaterText}</Typography.Text>
			</div>
			{isStartVerify && (
				<Verify2FASteps isOpen={isStartVerify} onClose={() => setIsStartVerify(false)} />
			)}
		</RegistrationLayout>
	);
};
